module.exports = __webpack_public_path__ + "img/b922fb33285ce98475b22916e959343b.png";